import React from 'react'

import Header from '../../../components/header'
import Togglable from '../../../components/togglable'
import WhatsappButton from './whatsapp-button'

import * as S from './styles'

import IProps from './props'

const Faq = ({ states, handlers }: IProps) => (
  <S.Container>
    <Header title="FAQ - Perguntas frequentes" />
    <S.Content>
      {states.resource.map((item) => (
        <Togglable
          key={item.id}
          title={item.title}
          message={item.message}
          isOpen={states.openFaq === item.id}
          onToggle={() => handlers.handleToggle(item.id)}
        />
      ))}
    </S.Content>

    <WhatsappButton />
  </S.Container>
)

export default Faq
